import type { AxiosRequestConfig } from "axios";

const MUTATING_METHODS = ["post", "put", "patch", "delete"];

export const isPublicIdempotentMutation = (
  config: AxiosRequestConfig | undefined,
): boolean => {
  if (
    config?.withCredentials !== false ||
    !MUTATING_METHODS.includes(config.method?.toLowerCase() ?? "")
  )
    return false;

  return Object.entries(config.headers ?? {}).some(
    ([name, value]) =>
      name.toLowerCase() === "idempotency-key" &&
      typeof value === "string" &&
      value.trim().length > 0,
  );
};
